import { createSelector } from '@ngrx/store';
import { featureSelect, FeatureState } from '../settings';

export const getRecords = createSelector(
    featureSelect,
    (state: FeatureState) => state.categories
);

export const getRecordById = createSelector(
    featureSelect,
    (state: FeatureState, recordId) => state.categories.find(record => record.id.toString() === recordId.toString())
);
